<script setup lang="ts">
import { useSettingsStore } from '@bv/stores/settings'
import { computed } from 'vue'

const settingStore = useSettingsStore()

const layoutType = computed(() => settingStore.layoutType)

const buttonProps = computed(() => {
  if (layoutType.value === 'new') {
    return {
      class: 'w-10 h-10',
      variant: 'text',
      color: 'currentcolor'
    } as const
  }
  return {
    class: 'w-8 h-8 p-0',
    variant: 'primary',
    rounded: 'circle',
    color: 'white'
  } as const
})

const iconProps = computed(() => {
  if (layoutType.value === 'new') {
    return {
      icon: 'bvi-message-question',
      size: 'lg'
    } as const
  }
  return {
    icon: 'bvi-question-circle',
    size: 'md'
  } as const
})
</script>

<template>
  <bv-menu eager location="end top" offset="20">
    <template #activator="{ props }">
      <bv-btn v-bind="{ ...props, ...buttonProps }">
        <bv-icon v-bind="iconProps" />
      </bv-btn>
    </template>
    <div class="support-btn">
      <div class="support-list">
        <a href="https://support.bevatel.com/portal/en/home" target="_blank" class="item">
          <img src="@/assets/images/layout/sidebar/icons/support/user-guide.svg" class="icon" />
          {{ $t('account.support_list.user_guide') }}
        </a>
        <a href="https://support.bevatel.com/portal/en/kb" target="_blank" class="item">
          <img src="@/assets/images/layout/sidebar/icons/support/get-support.svg" class="icon" />
          {{ $t('account.support_list.zoho_ticket_support') }}
        </a>
        <a
          href="https://api.whatsapp.com/send?phone=966920007031&text=I%20need%20support%20on%20Bevatel%20Business%20Chatdescription"
          target="_blank"
          class="item"
        >
          <img
            src="@/assets/images/layout/sidebar/icons/support/whatsapp-support.svg"
            class="icon"
          />
          {{ $t('account.support_list.whatsapp_support') }}
        </a>
        <a
          href="https://support.bevatel.com/portal/en/newticket?departmentId=512739000011908329&layoutId=512739000011914614"
          target="_blank"
          class="item"
        >
          <img
            src="@/assets/images/layout/sidebar/icons/support/request-feature.svg"
            class="icon"
          />
          {{ $t('account.support_list.request_feature') }}
        </a>
        <a
          href="https://support.bevatel.com/portal/en/newticket?departmentId=512739000011908329&layoutId=512739000011914614"
          target="_blank"
          class="item"
        >
          <img src="@/assets/images/layout/sidebar/icons/support/report-bug.svg" class="icon" />
          {{ $t('account.support_list.report_bug') }}
        </a>
        <!-- <a href="" target="_blank" class="item">
          <img src="@/assets/images/layout/sidebar/icons/support/24-support.svg" class="icon" />
          {{ $t('account.support_list.contact_support') }}
        </a> -->
      </div>
    </div>
  </bv-menu>
</template>

<style lang="scss" scoped>
.support-btn {
  .support-list {
    background-color: #fff;
    width: 183px;
    padding-block: 8px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    border-radius: 4px;
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.24);

    &:dir(ltr) {
      left: calc(100% + 4px);
    }
    &:dir(rtl) {
      right: calc(100% + 4px);
    }

    .item {
      display: flex;
      align-items: center;
      gap: 4px;
      font-size: 12px;
      line-height: 12px;
      padding-block: 5px;
      padding-inline: 8px;
      position: relative;

      &,
      &:visited,
      &:focus,
      &:active {
        color: #999999;
      }

      &:focus,
      &:focus-within,
      &:active,
      &:hover {
        background-color: #efefef;
      }

      &::after {
        content: '';
        position: absolute;
        width: calc(100% - 8px * 2);
        height: 1px;
        bottom: -2.5px;
        left: 8px;
        background-color: #f2f2f2;
      }

      &:last-of-type::after {
        display: none;
      }

      .icon {
        width: 12px;
        height: 12px;
      }
    }
  }
}
</style>
